const styles = {
  appHeader: () => ({
    padding: '20px',
    width: '90%',
    marginBottom: '20px',
    display: 'flex',
  }),
  headerTitle: ({ toolForegroundColor }) => ({
    color: toolForegroundColor || 'rgb(43, 30, 94)',
    fontSize: '120%',
    margin: '0',
    textAlign: 'left',
    margin: '20px',
    maxWidth: '80%',
  }),
  listContainer: () => ({
    padding: '40px',
    borderRadius: '50px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgb(43, 30, 94)',
    maxWidth: '70%',
    width: '300px',
    margin: 'auto',
  }),
  listContainer2: () => ({
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  listItemContainer: () => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }),
  floatingImage: () => ({
    maxWidth: '80%',
    height: 'auto',
    margin: '20px',
    borderRadius: '30px',
    transition: 'transform 0.3s ease-in-out',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  }),
  imageText: ({ toolForegroundColor }) => ({
    color: toolForegroundColor || 'rgb(43, 30, 94)',
    alignSelf: 'flex-start',
    marginLeft: '40px',
  }),
  floatingImageHover: () => ({
    transform: 'scale(1.1) translateY(-5px)',
  }),
  listItemId: ({ toolForegroundColor }) => ({
    margin: '30px',
    color: toolForegroundColor || 'rgb(43, 30, 94)'
  }),
  listButton: ({ allForegroundColor, allBackgroundColor }) => ({
    userSelect: 'none',
    padding: '16px',
    margin: '0 0 8px 0',
    backgroundColor: allBackgroundColor || 'rgb(43, 30, 94)',
    color: allForegroundColor || 'white',
    borderRadius: '30px',
    width: 'max-content',
    flexGrow: '1',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  }),
  listButtonHover: () => ({
    backgroundColor: '#f7f8f7',
    color: '#555',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgb(43, 30, 94)',
  }),
  submitButtonContainer: () => ({
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
  }),
  submitButton: ({ allForegroundColor, allBackgroundColor }) => ({
    backgroundColor: allBackgroundColor || '00FF00',
    color: allForegroundColor || 'white',
    maxWidth: '60%',
    width: '300px',
    paddingTop: '10px',
    paddingBottom: '10px',
    marginTop: '50px',
    borderRadius: '20px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  }),
  submitButtonHover: () => ({
    backgroundColor: '#f1c88a',
    color: 'black',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgb(43, 30, 94)',
  }),
  submitButton2: ({ allForegroundColor, allBackgroundColor }) => ({
    backgroundColor: allBackgroundColor || 'rgb(43, 30, 94)',
    color: allForegroundColor || 'white',
    maxWidth: '60%',
    width: '400px',
    paddingTop: '10px',
    paddingBottom: '10px',
    marginTop: '50px',
    borderRadius: '20px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  }),
  submitButton2Hover: () => ({
    backgroundColor: '#f1c88a',
    color: 'black',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgb(43, 30, 94)',
  }),
  reportButtonsContainer: () => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  }),
  reportButton: ({ twoButtonBackColor, twoButtonForeColor }) => ({
    margin: '4px',
    backgroundColor: twoButtonBackColor || 'white',
    color: twoButtonForeColor || 'black',
    borderRadius: '20px',
    padding: '10px',
  }),
  reportButtonHover: () => ({
    margin: '4px',
    backgroundColor: 'rgb(43, 30, 94)',
    borderRadius: '20px',
    padding: '10px',
    color: 'white',
  }),
  backArrow: () => ({
    display: 'flex',
    alignItems: 'flex-start',
  }),
  sweetLoading: () => ({
    height: '600px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })
};

export default styles;
